import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./card.module.scss";
import CircleIcon from "../CircleIcon";

function Card(props) {
  const {
    number,
    backgroundColor,
    color,
    numberDirection,
    children,
    height
  } = props;
  return (
    <section
      style={{
        backgroundColor,
        color,
        height: Number.isInteger(height) ? `${height}px` : `auto`
      }}
      className={styles.root}
    >
      <CircleIcon
        className={classNames(styles.icon, styles[`icon_${numberDirection}`])}
        color={color}
      >
        <div className={styles.number}>{number}</div>
      </CircleIcon>
      <div className={styles.content}>{children}</div>
    </section>
  );
}

Card.defaultProps = {
  numberDirection: `right`,
  height: 315
};

Card.propTypes = {
  number: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  numberDirection: PropTypes.string,
  children: PropTypes.element
};

export default Card;
